import { Play } from "lucide-react";

import { FileThumbnail } from "../FileThumbnail";
import { getFileSizeFromBase64 } from "../../utils";
import { DetectedFile } from "../../types";

interface VideoThumbnailProps {
  detectedFile: DetectedFile;
  data: string;
  onClick?: () => void;
}

export const VideoThumbnail = ({ detectedFile, data, onClick }: VideoThumbnailProps) => (
  <FileThumbnail
    icon={<Play className="h-6 w-6 text-gray-600" />}
    title="Video File"
    subtitle={`${
      detectedFile.extension?.toUpperCase() || "VIDEO"
    } • ${getFileSizeFromBase64(data)}`}
    onClick={onClick}
  />
);
